// components/AIStyleGuide.tsx
import { Settings2, CheckCircle, ChevronDown } from 'lucide-react';

interface StyleSuggestion {
  product_type: string;
  //content_style_tone: string;
  content_style_focus_features: string;
  content_style_emphasis_keywords: string;
}

interface AIStyleGuideProps {
  suggestions: StyleSuggestion[];
  expanded: boolean;
  onExpandChange: (expanded: boolean) => void;
}

export const AIStyleGuide = ({
  suggestions,
  expanded,
  onExpandChange,
}: AIStyleGuideProps) => {
  if (!suggestions?.length) return null;

  const SuggestionCard = ({ suggestion }: { suggestion: StyleSuggestion }) => (
    <div className="p-4 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg border border-blue-100">
      <div className="flex items-start gap-3">
        <Settings2 className="w-5 h-5 flex-shrink-0 text-blue-600 mt-1" />
        <div>
          <h4 className="text-blue-800 font-medium">
            {suggestion.product_type.charAt(0).toUpperCase() + suggestion.product_type.slice(1)} Content Guide
          </h4>
          <ul className="mt-2 space-y-2">
            {/* <li className="flex gap-2">
              <CheckCircle className="w-4 h-4 text-green-500 shrink-0 mt-0.5" />
              <span className="text-sm text-gray-600">{suggestion.content_style_tone}</span>
            </li> */}
            <li className="flex gap-2">
              <CheckCircle className="w-4 h-4 text-green-500 shrink-0 mt-0.5" />
              <span className="text-sm text-gray-600">{suggestion.content_style_focus_features}</span>
            </li>
            <li className="flex gap-2">
              <CheckCircle className="w-4 h-4 text-green-500 shrink-0 mt-0.5" />
              <span className="text-sm text-gray-600">{suggestion.content_style_emphasis_keywords}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );

  return (
    <div className="space-y-4">
      <SuggestionCard suggestion={suggestions[0]} />

      {suggestions.length > 1 && (
        <>
          <div
            onClick={() => onExpandChange(!expanded)}
            className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800 cursor-pointer"
          >
            <ChevronDown
              className={`w-4 h-4 transition-transform duration-200 ${
                expanded ? "rotate-180" : ""
              }`}
            />
            {expanded
              ? "Show fewer categories"
              : `View ${suggestions.length - 1} more categories`}
          </div>

          {expanded && (
            <div className="border-l-2 border-blue-100 pl-4 space-y-4">
              {suggestions.slice(1).map((suggestion, index) => (
                <SuggestionCard key={index} suggestion={suggestion} />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};